var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccountCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9716 9.57618H21.7571L21.1227 5.9817C20.9768 5.14689 20.1698 4.58939 19.3427 4.73333L3.20018 7.58031C2.36633 7.72712 1.80691 8.52643 1.95468 9.36124L3.67612 19.1218C3.74713 19.5258 3.9707 19.8789 4.30654 20.1149C4.5685 20.2982 4.87268 20.3942 5.18549 20.3942C5.27569 20.3942 5.36589 20.3865 5.45609 20.3702L6.04429 20.2663V21.0044C6.04429 21.8517 6.73325 22.5407 7.58053 22.5407H23.9716C24.8189 22.5407 25.5088 21.8517 25.5088 21.0044V11.1124C25.5088 10.2651 24.8189 9.57618 23.9716 9.57618ZM24.0349 11.1124V12.5575H7.52398L7.58053 11.05L24.0349 11.1124ZM5.12696 18.8666L3.6838 10.6835L3.45638 9.03115L19.6718 6.23694L20.2609 9.57618H7.58053C6.73325 9.57618 6.04429 10.2651 6.04429 11.1124V18.744L5.12696 18.8666ZM23.9716 21.0668L7.51816 21.0044V15.1665H24.0349V21.0044C24.0349 21.039 24.0061 21.0668 23.9716 21.0668Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountCard);
export default __webpack_public_path__ + "static/media/account-card.4b586f81c0aea5a73f7b6d41539f52a2.svg";
export { ForwardRef as ReactComponent };